// @ts-check
import React from "react"
import { OverlayPanel } from "../atoms/OverlayPanel.atom"
import { ShortcutItem } from "./ShortcutItem.molecule"

/**
 * @typedef {import("./ShortcutOverlay.molecule.types").ShortcutOverlayProps} ShortcutOverlayProps
 */

export const ShortcutOverlay = React.forwardRef(
  /**
   *
   * @param {ShortcutOverlayProps} props
   * @param {React.Ref<import("primereact/overlaypanel").OverlayPanel>} ref
   */
  ({ shortcuts }, ref) => {
    if (!shortcuts.length) {
      return null
    }

    return (
      <OverlayPanel className="shortcut-overlay" ref={ref}>
        <h2 className="shortcut-overlay__header">
          <i className="pi pi-bolt shortcut-overlay__icon" />
          Atajos
        </h2>
        {shortcuts.map((item) => (
          <ShortcutItem
            key={item.title}
            title={item.title}
            description={item.description}
            to={item.to}
            clientCode={item.clientCode}
            state={item.state}
            isLink={item.isLink}
          />
        ))}
      </OverlayPanel>
    )
  }
)
